import { Chip, ColourVariant, IconVariant } from '@weareopenr/component-library';

type EntityKey = 'price-scheme' | 'option-group';
type StatusMap = Record<string, { colour: ColourVariant; icon?: IconVariant }>;

const priceSchemeStatusMap: StatusMap = {
  'In Use': { colour: 'kale', icon: 'tick' },
  Scheduled: { colour: 'honey', icon: 'scheduled' },
  'Not In Use': { colour: 'blueberry', icon: 'pause' },
};

const optionGroupStatusMap: StatusMap = {
  Bundle: { colour: 'blueberry' },
  Standard: { colour: 'grape' },
  'Non-food': { colour: 'kale' },
  Modifier: { colour: 'honey' },
};

const statusMaps: Record<EntityKey, StatusMap> = {
  'price-scheme': priceSchemeStatusMap,
  'option-group': optionGroupStatusMap,
};

type StatusChipProps = { entity: EntityKey; status: string };

export const StatusChip = ({ entity, status }: StatusChipProps) => {
  const map = statusMaps[entity];
  const chipProps = (map && map[status]) || { colour: 'blueberry' };

  return <Chip label={status} backgroundColour={chipProps.colour} icon={chipProps.icon} />;
};
